import WidgetMetricDisplay from "@/components/common/WidgetMetricDisplay";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { WidgetTitle } from "@/components/widgets/WidgetTitle";
import React from "react";
import { RotateCcw } from "lucide-react";

const TransferredRateWidget: React.FC<{ data: { value: number; comparisonPercentage?: number }; icon?: React.ReactNode; loading?: boolean; error?: string }> = ({ data, loading }) => (
  <div className="w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#3C5C73] p-3">
    <div className="flex flex-row items-center justify-between">
      <WidgetTitle className="truncate">Transferred Rate (%)</WidgetTitle>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <span className="cursor-pointer">
              <RotateCcw className="h-4 w-4 text-primary dark:text-white" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p className="max-w-xs text-xs">
              The percentage of transferred calls within the given time.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div>
      <WidgetMetricDisplay
        value={data.value}
        invertColors={true}
        comparisonPercentage={data.comparisonPercentage}
        loading={loading}
        format="percentage"
      />
    </div>
  </div>
);

export default TransferredRateWidget; 